import { Divider, makeStyles } from '@rneui/themed'
import { onlineManager } from '@tanstack/react-query'
import { font } from 'app/theme'
import { ItemViewContentComponent, SummaryItem } from 'home/types'
import React from 'react'
import { Pressable, View } from 'react-native'
import { AvatarRow } from 'schedule/views/event/time_off_requests/store_time_off'
import { TileItemDescription } from './description'
import { Title } from './title'

export type Props = {
  item: SummaryItem
  ContentComponent?: ItemViewContentComponent
  color?: string
  error?: Error
  onPress?(): void
}

export function TileItemView({
  item,
  ContentComponent,
  color,
  error,
  onPress,
}: Props) {
  const styles = useStyles(color)

  return (
    <Pressable
      style={styles.container}
      onPress={onPress}
      disabled={!onlineManager.isOnline()}
    >
      <Title title={item.title} color={color} showCaret />
      <Divider style={styles.divider} />

      {item.userList ? (
        <View style={{ flex: 1, marginTop: 5 }}>
          <AvatarRow
            users={item.userList}
            avatarSize={20}
            avatarCount={6}
            centered
          />
        </View>
      ) : null}

      {ContentComponent ? (
        <ContentComponent
          item={item}
          color={color}
          error={error}
          onPress={onPress}
        />
      ) : item.description ? (
        <TileItemDescription
          description={item.description}
          error={error}
          numberOfLines={2}
          textStyle={styles.description}
        />
      ) : null}
    </Pressable>
  )
}

const useStyles = makeStyles((theme, color: string | undefined) => ({
  container: {
    flex: 1,
  },
  title: {
    fontSize: 16,
    lineHeight: 30,
    opacity: 0.6,
  },
  caret: {
    fontSize: 30,
    lineHeight: 30,
    opacity: 0.4,
  },
  description: {
    fontSize: 13,
    marginHorizontal: 16,
    marginVertical: 10,
    opacity: 0.8,
    color: color,
  },

  titleSection: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 2,
  },



  divider: {
    opacity: 0.3,
    backgroundColor: color,
  },

  badgeContainer: {
    borderWidth: 1,
    borderColor: 'red',
    borderRadius: 4,
    alignSelf: 'flex-start',
  },

  badgeText: {
    color: 'red',
    paddingHorizontal: 4,
    paddingVertical: 1,
    fontSize: 12,
    fontFamily: font.bold,
  },
}))
